<template>
  <v-dialog v-model="infoDialog"
            width="640">
    <h2 :class="$style.modalTitle">
      What's the Collection Statute Expiration Date?
    </h2>
    <p>
      Once a tax return has been filed, the IRS clock starts ticking for a period of
      10 years to legally collect the tax debt owed by taxpayer.
    </p>
    <p>
      Example: Bob Smith filed his 2006 tax return on March 30th of 2007. He owed the
      IRS $2,659.00 which he could not pay but he filed his tax return in a timely
      manner. The IRS has 10 years to collect the $2,659.00 Mr. Smith owes
      (plus accrued penalties and interest) which then gives a Collection Statute
      Expiration Date of March 30th, 2017.
    </p>
    <p>
      This example also illustrates how not filing or filing late can cost a taxpayer
      more money and extends the duration of his / her tax liability.
    </p>
    <div :class="$style.modalButtons">
      <app-button
        text="OK"
        button-style="accent"
        :class="$style.okBtn"
        @click="closeInfo($event)"
      />
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    infoDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeInfo(e) {
      this.$emit('close', e);
    },
  },
};
</script>

<style lang="scss" module>
.modalTitle {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.modalButtons {
  display: flex;
  justify-content: center;
}

.okBtn {
  padding: 9px 86px;
  margin-bottom: 20px;
}
</style>
